<script setup lang="ts">
	import {useAvailability} from '@/store/availability.store';
	import {storeToRefs} from 'pinia';
	import {computed, ref} from 'vue';

	const availability = useAvailability();
	const {exportWeeks, firstExportWeek} = storeToRefs(availability);

	const exportUrl = availability.getExportUrl();
	const fromSelectedWeek = ref(firstExportWeek.value);
	const toSelectedWeek = ref(firstExportWeek.value);

	const getAvailabilityExportUrl = computed(() => `${exportUrl}&from=${fromSelectedWeek.value}&to=${toSelectedWeek.value}`);
	const getAvailabilityExportPatUrl = computed(() => `${getAvailabilityExportUrl.value}&pat=true`);

	const setFromWeek = (event: Event): void => {
		if (!event) {
			return;
		}

		const element = event.target as HTMLInputElement;
		fromSelectedWeek.value = element.value;
	};

	const setToWeek = (event: Event): void => {
		if (!event) {
			return;
		}

		const element = event.target as HTMLInputElement;
		toSelectedWeek.value = element.value;
	};
</script>

<template>
	<div>
		<h2 class="catalog-modal__header">
			{{ $t('site.products.overview.availability.export.modal.title') }}
		</h2>

		<p>{{ $t('site.products.overview.availability.export.modal.text') }}</p>

		<div class="catalog-export-wrapper">
			<span class="catalog-export__select-container">
				<label for="selectExportWeekFrom">
					{{ $t('site.products.overview.availability.export.modal.label.from.text') }}:</label>

				<select
					:value="fromSelectedWeek"
					@change="setFromWeek($event)"
					id="selectExportWeekFrom">
					<option v-for="(option, key) in exportWeeks" :key="key" :value="key">
						{{ option }}
					</option>
				</select>
			</span>

			<span class="catalog-export__select-container">
				<label for="selectExportWeekTo">
					{{ $t('site.products.overview.availability.export.modal.label.to.text') }}:</label>

				<select
					:value="toSelectedWeek"
					@change="setToWeek($event)"
					id="selectExportWeekTo">
					<option v-for="(option, key) in exportWeeks" :key="key" :value="key">
						{{ option }}
					</option>
				</select>
			</span>
		</div>

		<div class="catalog-export__download-wrapper">
			<a v-bind:href="getAvailabilityExportUrl" target="_blank">
				<svg class="icon-download" width="15" height="18">
					<use xlink:href="/assets/images/build/svg-sprite.min.svg#download"></use>
				</svg>
				{{ $t('site.products.overview.availability.export.modal.button.download.text') }}
			</a>
		</div>

		<div class="catalog-export__download-wrapper">
			<a v-bind:href="getAvailabilityExportPatUrl" target="_blank">
				<svg class="icon-download" width="15" height="18">
					<use xlink:href="/assets/images/build/svg-sprite.min.svg#download"></use>
				</svg>
				{{ $t('site.products.overview.availability.export.modal.button.download.pat.text') }}
			</a>
		</div>
	</div>
</template>
